import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
  selector: 'cs-loading',
  standalone: true,
  templateUrl: './loading.component.html',
  styleUrls: ['./loading.component.scss'],
  imports: [CommonModule]
})
export class LoadingComponent {
  @Input()
  public isLoading: boolean = false;

  @Input()
  public loader: 'circle' | 'cube' | 'flip' = 'circle';

  @Input()
  public displayMessage: string = '';

  @Input()
  public isLoadTop: boolean = false;
}
